import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { qrFrameColor } from "../../../../../redux/slices/qrFrames";
import InputColor from "../../../../../components/input/inputColor";

function FrameQrColor() {
  const lang = useSelector(
    (state) => state.changeLang.language.stepThree.frame[0]
  );
  const stateFrameColor = useSelector((state) => state.qrFrames.frameColor);

  const dispatch = useDispatch();
  const [frameColor, setFrameColor] = useState(stateFrameColor);

  useEffect(() => {
    setFrameColor(stateFrameColor);
  }, [stateFrameColor]);

  useEffect(() => {
    dispatch(qrFrameColor(frameColor));
  }, [frameColor]);

  return (
    <InputColor
      value={frameColor}
      onChange={(color) => setFrameColor(color)}
      label={lang}
    />
  );
}

export default memo(FrameQrColor);
